import { Download, ExternalLink, Mic, Monitor, Map } from "lucide-react";

export default function ModsTab() {
  const mods = [
    {
      name: "TOA HUD Mod",
      badge: "Fabric",
      description: "Customise and improve the server HUD, including health bars, skill displays, spacing, text sizing and other HUD presentation options.",
      href: "https://forums.theonesabove.com/thread/toa-hud-mod",
      icon: <Monitor className="toa-mod-card-icon-svg" />,
    },
    {
      name: "TOA Minimap",
      badge: "Fabric",
      description: "The official TOA minimap, built for the server with smooth player and NPC markers and TOA-focused navigation.",
      href: "https://forums.theonesabove.com/thread/toa-minimap-mod",
      icon: <Map className="toa-mod-card-icon-svg" />,
    },
    {
      name: "Simple Voice Chat",
      badge: "Fabric",
      description: "Enable proximity voice chat in-game so you can speak naturally with nearby players while exploring, roleplaying and playing on TOA RP.",
      href: "https://forums.theonesabove.com/thread/simple-voice-chat",
      icon: <Mic className="toa-mod-card-icon-svg" />,
    },
  ];

  return (
    <div className="toa-mods-tab">
      <div className="toa-mods-head">
        <div className="toa-mods-eyebrow">Client Downloads</div>
        <div className="toa-mods-title">The Ones Above Mods</div>
        <div className="toa-mods-desc">
          Optional client-side mods supported for The Ones Above. Choose a mod below to open its installation guide and download instructions.
        </div>
      </div>

      <div className="toa-mods-grid">
        {mods.map(mod => (
          <a key={mod.name} href={mod.href} className="toa-mod-card-link">
            <div className="toa-mod-card">
              <div className="toa-mod-card-layout">
                <div className="toa-mod-card-icon">{mod.icon}</div>
                <div className="toa-mod-card-content">
                  <div className="toa-mod-card-title-row">
                    <div className="toa-mod-card-title">{mod.name}</div>
                    <span className="toa-mod-card-badge">{mod.badge}</span>
                  </div>
                  <div className="toa-mod-card-description">{mod.description}</div>
                  <div className="toa-mod-card-cta">
                    <Download />
                    <span>View Mod &amp; Installation Guide</span>
                    <ExternalLink className="toa-mod-card-external" />
                  </div>
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
